import { useEffect, useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalEditSocial.css";
import { contentService } from "../../services/content.service";
import { closeModal, showModal } from "../../utils/functions/modal";
import { DEFAULT_SOCIAL_ICON, socialIcons } from "../../utils/functions/socials";

const ModalEditSocial = ({ setMessage, social, onSuccess }) => {
  const [nombre, setNombre] = useState("");
  const [url, setUrl] = useState("");
  const [icono, setIcono] = useState(DEFAULT_SOCIAL_ICON);
  const [orden, setOrden] = useState(0);

  useEffect(() => {
    setNombre(social?.nombre || "");
    setUrl(social?.url || "");
    setIcono(social?.icono || DEFAULT_SOCIAL_ICON);
    setOrden(social?.orden ?? 0);
  }, [social]);

  const handleSubmitSocial = async (e) => {
    e.preventDefault();
    if (!social?.id) return;

    closeModal(".container-modal-edit-social");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Editando red social...",
      status: 1000,
    });

    const response = await contentService.editSocial({
      id: social.id,
      nombre: nombre.trim(),
      url: url.trim(),
      icono,
      orden: parseInt(orden) || 0,
    });

    setTimeout(() => {
      if (response.data.status === 200) {
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-edit-social">
      <div className="modal modal-edit-social">
        <div className="header-modal">
          <h3>Editar Red Social</h3>
          <button onClick={() => closeModal(".container-modal-edit-social")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitSocial} className="body-modal">
          <div className="input">
            <label htmlFor="nombreEditSocial">Nombre</label>
            <input
              type="text"
              id="nombreEditSocial"
              name="nombreEditSocial"
              required
              onChange={(e) => setNombre(e.target.value)}
              value={nombre}
            />
          </div>
          <div className="input">
            <label htmlFor="urlEditSocial">Link</label>
            <input
              type="url"
              id="urlEditSocial"
              name="urlEditSocial"
              required
              onChange={(e) => setUrl(e.target.value)}
              value={url}
            />
            <span className="hint">Tiene que empezar con http:// o https://</span>
          </div>
          <div className="input">
            <label htmlFor="iconoEditSocial">Icono</label>
            <select
              id="iconoEditSocial"
              name="iconoEditSocial"
              onChange={(e) => setIcono(e.target.value)}
              value={icono}
            >
              {Object.entries(socialIcons).map(([slug, { label }]) => (
                <option key={slug} value={slug}>
                  {label}
                </option>
              ))}
            </select>
            <span className="hint">Es el que se muestra en el footer de la web</span>
          </div>
          <div className="input">
            <label htmlFor="ordenEditSocial">Orden</label>
            <input
              type="number"
              id="ordenEditSocial"
              name="ordenEditSocial"
              onChange={(e) => setOrden(e.target.value)}
              value={orden}
              min={0}
            />
            <span className="hint">Determina el orden en que se muestra en el footer (menor primero)</span>
          </div>

          <button className="btn-add-product">GUARDAR CAMBIOS</button>
        </form>
      </div>
    </div>
  );
};

export default ModalEditSocial;
